import loadable from '@loadable/component';
import sotyWinnersQuery from './winners-query.graphql';
import sotyCategoryNomineesQuery from './category-nominees-query.graphql';

const ShopOfTheYearLeaderboard = loadable(() =>
  import(
    /* webpackChunkName: "shop-of-the-year" */
    './leaderboard'
  )
);

const ShopOfTheYearCategoryNominees = loadable(() =>
  import(
    /* webpackChunkName: "shop-of-the-year" */
    './category-nominees'
  )
);

const ShopOfTheYearWinners = loadable(() =>
  import(
    /* webpackChunkName: "shop-of-the-year" */
    './winners'
  )
);

ShopOfTheYearWinners.graphQL = sotyWinnersQuery;

ShopOfTheYearWinners.variables = ({ year }) => ({
  year: parseInt(year, 10),
});

ShopOfTheYearCategoryNominees.graphQL = sotyCategoryNomineesQuery;

ShopOfTheYearCategoryNominees.variables = ({ year, id, offset }) => ({
  year: parseInt(year, 10),
  id: parseInt(id, 10),
  offset: parseInt(offset, 10) || 0,
});

export {
  ShopOfTheYearLeaderboard,
  ShopOfTheYearCategoryNominees,
  ShopOfTheYearWinners,
};
